<template>
    <div class="modal fade" id="modalIgnoreInvoice" role="dialog" data-keyboard="false" data-backdrop="static">
      <div
        class="modal-dialog modal-dialog-centered modal-scroll"
        style="max-width: 700px;"
      >
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title black-text" style="font-weight: bold">
               Alasan Ignore
              </h4> 
            </div>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <textarea
                    class="form-control"
                    :class="{
                      'form-control border border-danger': $v.inputIgnoreReason.$error,
                    }"
                    rows="4"
                    placeholder="Berikan penjelasan anda"
                    v-model.trim="$v.inputIgnoreReason.$model"
                  ></textarea>
            
            <div style="float: right">
                {{ inputIgnoreReason.trim().length }}/{{ maxInputIgnoreReasonLength }}
            </div>
            <div
                style="color: red; font-size: 12px"
                v-if="$v.inputIgnoreReason.$error && !$v.inputIgnoreReason.required"
            >
                Alasan Ignore tidak boleh kosong.
            </div>
            <div
                style="color: red; font-size: 12px"
                v-if="$v.inputIgnoreReason.$error && !$v.inputIgnoreReason.minLength"
            >
                Alasan Ignore setidaknya harus terdiri dari
                {{ $v.inputIgnoreReason.$params.minLength.min }} karakter.
            </div>
            <div
                style="color: red; font-size: 12px"
                v-if="$v.inputIgnoreReason.$error && !$v.inputIgnoreReason.maxLength"
            >
                Alasan Ignore maksimal terdiri dari 
                {{ $v.inputIgnoreReason.$params.maxLength.max }} karakter.
            </div>
          </div>
          <div class="modal-footer">
              <button
                class="btn btn-sm btn-danger"
                @click="closeIgnoreInvoiceModal"
              >
                Batal
              </button>
              <button class="btn btn-sm btn-primary" @click="showConfirmationModal">
                Simpan
              </button>
            </div>
        </div>
      </div>
    </div>
</template>

<script>
import Swal from "sweetalert2";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
export default {
  name: 'ModalIgnoreInvoice',
  props: ['invoiceIds'],
  data () {
    return {
      inputIgnoreReason : '',
      maxInputIgnoreReasonLength: 144,
    }
  },
  validations: {
    inputIgnoreReason: {
      required,
      minLength: minLength(5),
      maxLength: maxLength(144),
    },
  },
  methods:{
    closeIgnoreInvoiceModal() {
        this.$v.$reset();
        $("#modalIgnoreInvoice").modal("hide");
    },
    showConfirmationModal() {
        const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
                confirmButton: "btn btn-primary ml-2",
                cancelButton: "btn btn-secondary",
            },
            buttonsStyling: false
        });

        this.$v.$touch();
        if (this.$v.$invalid || this.$v.inputIgnoreReason.$error) {
        } else {
            swalWithBootstrapButtons
            .fire({
            title:
                "<strong style='font-size : 24px; font-weight : 600;'>Apakah anda yakin ingin ignore invoice ini ?</strong>",
            icon: "warning",
            width: "32rem",
            reverseButtons: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonText: `
                Save
            `,
            cancelButtonText: `
                Cancel
            `,
            })
            .then((result) => {
            if (result.isConfirmed) {
                this.ignoreInvoice();
            }
            });
        }
    },
    ignoreInvoice() {
        const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
                confirmButton: "btn btn-primary ml-2",
                cancelButton: "btn btn-secondary",
            },
            buttonsStyling: false
        });

        const arrId = this.invoiceIds.map(item => item.invoiceId)

        this.$http.post(`${process.env.IGNORE_OR_ACTIVATE_INVOICE}`,
        {
            ids: arrId,
            Ignored: true,
            IgnoredReason: this.inputIgnoreReason.trim()
        },
        {
          headers: {'Asani-Token':localStorage.getItem('jwt')}
        })
        .then(response => {
          if(response.data.status != 200) {
            swalWithBootstrapButtons.fire({
                title:"Oops...",
                html: `
                    <div style="max-width : 100%">
                        <span style="color : #F06400;font-size: 16px;">Ignore Invoice gagal</span>
                    </div>
                `,
                icon: "error",
                width: "32rem",
                reverseButtons: true,
                focusConfirm: false,
                confirmButtonText: `
                    Back
                `,
            }).then((result) => {
                if(result.isConfirmed) {
                    this.$v.$reset();
                    localStorage.setItem("selectedPendingInvoice", JSON.stringify([]))
                    window.location.reload()
                }
            });
          } else {
            swalWithBootstrapButtons.fire({
                title:"Success",
                html: `
                    <div style="max-width : 100%">
                        <span style="color : #565656;font-size: 16px;">Ignore Invoice berhasil dibuat</span>
                    </div>
                `,
                icon: "success",
                width: "32rem",
                reverseButtons: true,
                focusConfirm: false,
                confirmButtonText: `
                    OK
                `,
            }).then((result) => {
                if(result.isConfirmed) {
                    this.$v.$reset();
                    localStorage.setItem("selectedPendingInvoice", JSON.stringify([]))
                    window.location.reload()
                }
            });
          }
        })
        .catch(error => {
            swalWithBootstrapButtons.fire({
                title:"Oops...",
                html: `
                    <div style="max-width : 100%">
                        <span style="color : #F06400;font-size: 16px;">${error.response.data.message ? error.response.data.message : error.message}</span>
                    </div>
                `,
                icon: "error",
                width: "32rem",
                reverseButtons: true,
                focusConfirm: false,
                confirmButtonText: `
                    Back
                `,
            }).then((result) => {
                if(result.isConfirmed) {
                  if(error.response.data.status == 401) {
                    this.handleLogout()
                  } else {
                    this.$v.$reset();
                    localStorage.setItem("selectedPendingInvoice", JSON.stringify([]))
                    window.location.reload()
                  }
                }
            });
        })
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
      localStorage.removeItem('jwt')
      localStorage.removeItem('admin_name')
      localStorage.removeItem('roles')
      localStorage.removeItem('user_email')
      localStorage.removeItem('admin_id')
      localStorage.removeItem('changeCatalogPermission')
      this.$router.push('/')
    }
  },
  created(){
    this.admin = localStorage.getItem('admin_name')
    // this.cekLogin()
    // this.cekPermission()
  }
}
$(document).ready(function(){
  var self = this
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .title-square-background {
    background-color: #F8F9FB;
  }

  .invoice-overview-indicator{
    color: #000;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px; /* 157.143% */
    letter-spacing: -0.014px;
  }

  .invoice-overview-value {
    color: #000;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px; /* 110% */
    letter-spacing: -0.02px;
  }

  .most-overdue-title {
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px; /* 157.143% */
    letter-spacing: -0.014px;
  }

  .most-overdue-text {
    color: #2E3646;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px; /* 157.143% */
    letter-spacing: -0.014px;
  }

  .most-overdue-orange {
    color: #FF5252;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px; /* 157.143% */
    letter-spacing: -0.014px;
  }

@media (max-width: 767px) {
  .nav-side-menu {
    position: relative;
    width: 100%;
    margin-bottom: 10px;
  }
  .nav-side-menu .toggle-btn {
    display: block;
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 10 !important;
    padding: 3px;
    background-color: #ffffff;
    color: #000;
    width: 40px;
    text-align: center;
  }
  .brand {
    text-align: left !important;
    font-size: 22px;
    padding-left: 20px;
    line-height: 50px !important;
  }
}
@media (min-width: 767px) {
  .nav-side-menu .menu-list .menu-content {
    display: block;
  }
}
@media (max-width: 573px){
  .mobile-div{
    padding: 2px 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Invoicing/CustomComponent/ModalIgnoreInvoice.vue